export default __webpack_public_path__ + "static/media/marker.1a6d87b6.svg";